import { useCallback, useContext, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { marketingEventsService } from '../api/marketingEvents.service'
import { UserContext } from '../contexts/UserContext'
import { isGtmEnabled, sendGtmEvent } from '../utils/gtm'

export default function MarketingEventDispatcher() {
    const user = useContext(UserContext)
    const location = useLocation()
    const busy = useRef(false)

    const dispatchEvents = useCallback(async () => {
        if (!user || !isGtmEnabled() || busy.current) return
        busy.current = true
        try {
            const events = await marketingEventsService.claim()
            for (const item of events) {
                if (sendGtmEvent(item.name, item.event_id, item.payload)) {
                    await marketingEventsService.acknowledge(item.id)
                }
            }
        } catch (error) {
            console.error('Unable to deliver marketing events', error)
        } finally {
            busy.current = false
        }
    }, [user])

    useEffect(() => {
        dispatchEvents()
        const interval = window.setInterval(dispatchEvents, 20000)
        window.addEventListener('marketing:events-ready', dispatchEvents)
        window.addEventListener('focus', dispatchEvents)
        return () => {
            window.clearInterval(interval)
            window.removeEventListener('marketing:events-ready', dispatchEvents)
            window.removeEventListener('focus', dispatchEvents)
        }
    }, [dispatchEvents, location.pathname])

    return null
}
